import Icon from '@chakra-ui/icon'
import { HStack } from '@chakra-ui/layout'

import React from 'react'
import { Center } from '@chakra-ui/react'
import {
  DiJavascript,
  DiReact,
  DiMongodb,
  DiMysql,
  DiGoogleAnalytics,
  DiVisualstudio,
} from 'react-icons/di'
import {
  SiDotnet,
  SiExpress,
  SiFigma,
  SiPostman,
  SiVisualstudiocode,
} from 'react-icons/si'
import { FaJava } from 'react-icons/fa'

function Social() {
  return (
    <>
      <Center
        bg='transparent'
        fontSize='20'
        h='100px'
        fontWeight='bold'
        bgGradient='linear(to-r, red.400, blue.500, cyan.600)'
        bgClip='text'
      >
        Tools | Languages | Frameworks | Libraries learned over time.
      </Center>

      <HStack spacing='16'>
        <Icon as={DiMongodb} boxSize='50' />
        <Icon as={SiDotnet} boxSize='50' />
        <Icon as={DiReact} boxSize='50' />
        <Icon as={DiJavascript} boxSize='50' />
      </HStack>
      <HStack spacing='16'>
        <Icon as={DiMysql} boxSize='50' />
        <Icon as={SiFigma} boxSize='50' />
        <Icon as={DiGoogleAnalytics} boxSize='50' />
        <Icon as={SiVisualstudiocode} boxSize='50' />
      </HStack>
      <HStack spacing='16'>
        <Icon as={SiPostman} boxSize='50' />
        <Icon as={DiVisualstudio} boxSize='50' />
        <Icon as={SiExpress} boxSize='50' />
        <Icon as={FaJava} boxSize='50' />
      </HStack>
      <hr />
    </>
  )
}

export default Social
